import React from 'react';
import styles from './styles.module.scss';

export default function Mobile() {
  return <div></div>;
}
